import { EcoaAccessTokenFlax } from "@maven-rest/cdms/ecoa/EcoaAccessToken.flax";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouteProps } from "react-router-dom";
import { useRequest } from "@coralblack/flax";
import { sessionSlice } from "maven-lib/dist/states";
import { useRoute, useStringParam } from "@maven-surface/hooks";
import { ECOA_ACCESS_TOKEN_LANG } from "@maven-msg/lang/ecoa/accessToken";
import { MvnMessage } from "@maven-msg/lib/Message";

interface AccessTokenAuthProps extends RouteProps {}

export function AccessTokenAuth(props: AccessTokenAuthProps) {
  const { query } = useRoute();
  const dispatch = useDispatch();
  const accessToken = useStringParam(query?.t, true);

  const { request: requestVerifyEcoaAccessToken } = useRequest(
    { ...EcoaAccessTokenFlax.verifyEcoaAccessToken({ accessToken }) },
    {
      success: (resp) => {
        const state = props.location?.state as { targetPath: string };
        const targetPath = state?.targetPath || "/";
        dispatch(sessionSlice.actions.signIn({ ...resp, redirectTo: targetPath }));
      },
      error: () => {
        setTimeout(() => {
          dispatch(sessionSlice.actions.signOut());
        }, 3000);

        return MvnMessage(ECOA_ACCESS_TOKEN_LANG.ECOA_ACCESS_TOKEN_EXPIRED);
      },
    }
  );

  useEffect(() => {
    requestVerifyEcoaAccessToken({
      data: { accessToken },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="app-spinner" />;
}
